module.exports = __webpack_public_path__ + "img/bg-blue.756ffbe4.png";